"use strict";

module.exports = function getGroups(str) {
  return str.split(/[:\s+]/);
};